import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetoService } from './../../service/projeto.service';
import { Projeto } from './../../model/projeto';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-projetos',
  templateUrl: './admin-projetos.component.html',
  styleUrls: ['./admin-projetos.component.css']
})
export class AdminProjetosComponent implements OnInit {

  itens: Observable<Projeto[]>;
  display = false;
  item: Projeto = <Projeto>{};

  constructor(private service: ProjetoService, private confirmationService: ConfirmationService, private messageService: MessageService) { }

  ngOnInit() {
    this.itens = this.service.listar();
  }

  cadastrar() {
    this.item = <Projeto> {};
    this.item.id = this.service.criaId();
    this.display = true;
  }

  alterar(item: Projeto) {
    this.item = item;
    this.display = true;
  }

  excluir(item: Projeto) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o registro?',
      accept: () => {
          const task = this.service.delete(item.id);
          task.then(ret => {
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro Excluido com Sucesso' });
          }).catch(e => {
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Excluir' });
          });
      }
  });
  }

  salvar() {
    const task = this.service.salvar(this.item);
    task.then(ret => {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro Salvo com Sucesso' });
    }).catch(e => {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar' });
    });
    this.display = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin-projetos/admin-projetos.component.ts